import React, { useEffect, useState } from "react";
import { api } from "../lib/api";

export default function ImmigrationPerformance() {
  const [rows, setRows] = useState([]);
  const [month, setMonth] = useState("");

  useEffect(() => { api.get("/immigration/performance").then(r => { setRows(r.data.officers); setMonth(r.data.month); }); }, []);

  return (
    <div className="space-y-6">
      <div>
        <h1 className="heading-font text-3xl font-bold text-slate-900">Employee Performance — Immigration</h1>
        <p className="text-sm text-slate-500 mt-1">Factual metrics for {month} · Monthly and cumulative counts per Filing Officer / Filing Manager</p>
      </div>

      <div className="bg-white rounded-xl border border-slate-200 overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-xs uppercase text-slate-500">
            <tr>
              <th className="text-left px-4 py-3">Employee</th>
              <th className="text-right px-4 py-3">Assigned</th>
              <th className="text-right px-4 py-3">Active</th>
              <th className="text-right px-4 py-3">Prepared</th>
              <th className="text-right px-4 py-3">Submitted</th>
              <th className="text-right px-4 py-3">Reviewed</th>
              <th className="text-right px-4 py-3">Changes Required</th>
              <th className="text-right px-4 py-3">Submitted (Mo)</th>
              <th className="text-right px-4 py-3">Approved (Mo)</th>
              <th className="text-right px-4 py-3">Refused (Mo)</th>
              <th className="text-right px-4 py-3">Avg Prep Days</th>
            </tr>
          </thead>
          <tbody>
            {rows.map(o => (
              <tr key={o.officer_id} className="border-t border-slate-100 hover:bg-slate-50">
                <td className="px-4 py-3 font-medium">{o.officer_name}<div className="text-xs text-slate-500 capitalize">{o.role?.replace(/_/g," ")}</div></td>
                <td className="px-4 py-3 text-right">{o.assigned_files}</td>
                <td className="px-4 py-3 text-right">{o.active_workload}</td>
                <td className="px-4 py-3 text-right">{o.files_prepared}</td>
                <td className="px-4 py-3 text-right">{o.files_submitted}</td>
                <td className="px-4 py-3 text-right">{o.files_reviewed}</td>
                <td className="px-4 py-3 text-right">{o.files_requiring_corrections}</td>
                <td className="px-4 py-3 text-right font-semibold text-teal-700">{o.submitted_this_month}</td>
                <td className="px-4 py-3 text-right font-semibold text-emerald-700">{o.approved_this_month}</td>
                <td className="px-4 py-3 text-right font-semibold text-rose-700">{o.refused_this_month}</td>
                <td className="px-4 py-3 text-right">{o.avg_prep_days ?? "—"}</td>
              </tr>
            ))}
            {rows.length === 0 && <tr><td colSpan={11} className="text-center py-6 text-slate-500">No filing employees found.</td></tr>}
          </tbody>
        </table>
      </div>
      <p className="text-xs text-slate-500">Note: these are operational counts, not performance scores. Use alongside context (case complexity, tenure, workload allocation).</p>
    </div>
  );
}
